import { Paper, Typography } from "@mui/material";
import Layout from "../../components/Layout";
import { useT } from "../../i18n";
import EntsorgerDataTable from "../../components/entsorger/EntsorgerDataTable";
import ErrorAlert from "../../components/ErrorAlert";
import { notPermitted } from "../../errors";
import React from "react";
import Guard from "../../components/Guard";

export default function EntsorgerListe() {
  const { t } = useT("customer");
  const limit = parseInt(localStorage.getItem("entsorgerLimit") ?? "25", 10);
  return (
    <Layout title="Entsorger" showTitleInNav={false}>
      <Guard
        permission={"entsorger:list"}
        fallback={<ErrorAlert error={notPermitted()} />}
      >
        <Paper
          elevation={1}
          sx={{ marginTop: 2, padding: 3, marginLeft: 2, marginRight: 2 }}
        >
          <Typography variant="h5">Entsorger</Typography>
          <EntsorgerDataTable limit={limit} />
        </Paper>
      </Guard>
    </Layout>
  );
}
